class VariantMultiPicker extends HTMLElement {
  connectedCallback() {
    requestAnimationFrame(() => this.init());
  }

  init() {
    if (this._initialized) return;
    this._initialized = true;

    this.checkboxes = this.querySelectorAll('.variant-multi-picker__checkbox');
    this.summaryText = this.querySelector('.variant-multi-picker__summary-text');
    this.totalEl = this.querySelector('.variant-multi-picker__total');
    this.atcButton = this.querySelector('.variant-multi-picker__atc');
    this.errorEl = this.querySelector('.variant-multi-picker__error');
    this.currencySymbol = this.dataset.currencySymbol || '$';


    // Hide original variant picker + buy buttons
    document.documentElement.classList.add('multi-picker-active');

    // Checkbox toggles
// Checkbox toggles (delegated)
this.addEventListener('change', (e) => {
  const cb = e.target.closest('.variant-multi-picker__checkbox');
  if (!cb) return;
  const row = cb.closest('.variant-multi-picker__row');
  const qty = row?.querySelector('.variant-multi-picker__qty');
  if (qty) qty.classList.toggle('variant-multi-picker__qty--active', cb.checked);
  this.updateSummary();
  this.updateMediaGallery(cb);
});

// Quantity buttons (delegated)
this.addEventListener('click', (e) => {
  const btn = e.target.closest('.variant-multi-picker__qty-btn');
  if (!btn) return;
  this.handleQty({ currentTarget: btn });
});

    // Add to cart
    this.atcButton.addEventListener('click', () => this.addToCart());
  }

  // ─── Quantity ────────────────────────────────────────────────────────────────

 handleQty(e) {
    const btn = e.currentTarget || e.target;
    const qtyContainer = btn.closest('.variant-multi-picker__qty');
    if (!qtyContainer) return;
    const qtyEl = qtyContainer.querySelector('.variant-multi-picker__qty-value');
    if (!qtyEl) return;
    let val = parseInt(qtyEl.textContent, 10);
    if (btn.dataset.action === 'increase') val = Math.min(val + 1, 99);
    if (btn.dataset.action === 'decrease') val = Math.max(val - 1, 1);
    qtyEl.textContent = val;
    this.updateSummary();
  }

  // ─── Selection state ─────────────────────────────────────────────────────────

  getSelected() {
    return Array.from(this.checkboxes)
      .filter((cb) => cb.checked)
      .map((cb) => {
        const row = cb.closest('.variant-multi-picker__row');
        const qtyEl = row?.querySelector('.variant-multi-picker__qty-value');
        return {
          id: parseInt(cb.dataset.variantId, 10),
          price: parseInt(cb.dataset.variantPrice, 10),
          quantity: qtyEl ? parseInt(qtyEl.textContent, 10) : 1,
        };
      });
  }

  updateSummary() {
    const selected = this.getSelected();
    const count = selected.reduce((sum, s) => sum + s.quantity, 0);

    if (selected.length === 0) {
      this.summaryText.textContent = 'No items selected';
      this.totalEl.textContent = '';
      this.atcButton.disabled = true;
    } else {
      const total = selected.reduce((sum, s) => sum + s.price * s.quantity, 0);
      this.summaryText.textContent = `${count} item${count !== 1 ? 's' : ''} selected`;
      this.totalEl.textContent = `Total: ${this.formatMoney(total)}`;
      this.atcButton.disabled = false;
    }
  }

  formatMoney(cents) {
    return this.currencySymbol + (cents / 100).toFixed(2);
  }

  // ─── Media gallery ───────────────────────────────────────────────────────────

  updateMediaGallery(lastChanged) {
  const slideshow = document.querySelector('slideshow-component');
  if (!slideshow) return;

  const mediaItems = Array.from(slideshow.querySelectorAll('[data-media-id]'));
  if (!mediaItems.length) return;

  // Revert to first slide if unchecked
  if (!lastChanged.checked) {
    slideshow.select?.(0, undefined, { animate: true });
    return;
  }

  const variantId = lastChanged.dataset.variantId;
  if (!variantId) return;

  // Read variant→media mapping from embedded JSON
  const jsonEl = this.querySelector('.variant-multi-picker__variant-data');
  if (!jsonEl) return;

  let variants;
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  const variantData = variants.find((v) => String(v.id) === String(variantId));
  if (!variantData?.featured_media_id) return; // No variant-specific image

  // Find the slide index matching this media ID
  const targetIndex = mediaItems.findIndex(
    (el) => String(el.dataset.mediaId) === String(variantData.featured_media_id)
  );

  if (targetIndex >= 0) {
    slideshow.select?.(targetIndex, undefined, { animate: true });
  }
}


  // ─── Cart ────────────────────────────────────────────────────────────────────

  getSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  async addToCart() {
    const selected = this.getSelected();
    if (!selected.length) return;

    this.atcButton.disabled = true;
    this.atcButton.textContent = 'Adding...';
    this.errorEl.style.display = 'none';

    const sectionIds = this.getSectionIds();
    const items = selected.map((s) => ({ id: s.id, quantity: s.quantity }));
    const body = { items };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Could not add items to cart.');
      }

      // Reset selections and quantities
      this.checkboxes.forEach((cb) => (cb.checked = false));
      this.querySelectorAll('.variant-multi-picker__qty-value').forEach((el) => (el.textContent = '1'));
      this.updateSummary();

      // Revert gallery to main image
      this.updateMediaGallery({ checked: false, dataset: {} });

      this.atcButton.textContent = 'Added!';

      // Fire cart:update with correct structure for component-cart-items.js
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            data: {
              sections: data.sections || {},
            },
          },
        })
      );

      // Open cart drawer
      const cartDrawer = document.querySelector('cart-drawer-component');
      cartDrawer?.showDialog?.();

      setTimeout(() => {
        this.atcButton.textContent = 'Add selected to cart';
        this.atcButton.disabled = false;
      }, 2000);

    } catch (err) {
      this.errorEl.textContent = err.message;
      this.errorEl.style.display = 'block';
      this.atcButton.disabled = false;
      this.atcButton.textContent = 'Add selected to cart';
    }
  }
}

if (!customElements.get('variant-multi-picker')) {
  customElements.define('variant-multi-picker', VariantMultiPicker);
}
